import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { BsGithub } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";

function ProjectDetailCard({
  title,
  image,
  screenshots = [],
  description,
  technologies = [],
  github,
  demo,
  children,
}) {
  return (
    <Container fluid className="project-detail-section">
      <Container>
        <Card className="project-detail-card">
          <Row className="g-4 align-items-start">
            {/* LEFT */}
            <Col lg={4}>
              <div className="project-image-wrapper">
                <img src={image} alt={title} className="project-detail-image" />
              </div>
            </Col>

            {/* RIGHT */}

            <Col lg={8}>
              {/* Screenshot */}
              <h1 className="project-detail-title">{title}</h1>
              <div className="project-preview-grid">
                {screenshots.map((item, index) => (
                  <div className="preview-image" key={index}>
                    <img src={item} alt={`preview-${index}`} />
                  </div>
                ))}
              </div>
            </Col>

            <Col lg={12}>
              {/* Technology */}
              <div className="tech-list">
                {technologies.map((tech, index) => (
                  <span key={index} className="tech-badge">
                    {tech}
                  </span>
                ))}
              </div>

              {/* Description */}
              <div className="project-description">
                <p>{description}</p>
              </div>

              {/* Button */}
              <div
                className="project-btn-group"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "16px",
                  marginTop: "25px",
                  width: "100%",
                }}
              >
                {github && (
                  <Button className="project-btn" href={github} target="_blank">
                    <BsGithub />
                    &nbsp; GitHub
                  </Button>
                )}

                {demo && (
                  <Button
                    className="project-btn ms-3"
                    href={demo}
                    target="_blank"
                  >
                    <CgWebsite />
                    &nbsp; Live Demo
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Card>

        {/* Gallery / Video / Architecture */}

        {children}
      </Container>
    </Container>
  );
}

export default ProjectDetailCard;
